import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, TransitionGroup as _TransitionGroup } from "vue"

const _hoisted_1 = { class: "job-overview__secondheader" }
const _hoisted_2 = { class: "job-overview__secondheader-filter" }
const _hoisted_3 = { class: "job-overview__secondheader-sortby" }
const _hoisted_4 = { class: "job-overview__secondheader-sortby-text" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "job-overview__secondheader-sortby-checkmark" }, null, -1)
const _hoisted_6 = { class: "job-overview__secondheader-sortby-option" }
const _hoisted_7 = {
  key: 0,
  class: "job-overview__secondheader-results"
}
const _hoisted_8 = { class: "job-overview__filters__fields" }
const _hoisted_9 = { class: "job-overview__filters__fields-titles" }
const _hoisted_10 = {
  key: 0,
  class: "job-overview__filters__search"
}
const _hoisted_11 = { class: "job-overview__filters__search-icon" }
const _hoisted_12 = ["onUpdate:modelValue", "onInput"]
const _hoisted_13 = ["for"]
const _hoisted_14 = ["id", "value", "onUpdate:modelValue"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "job-overview__filters__options-checkmark" }, null, -1)
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 0,
  class: "job-overview__filters__seeresults"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "job-overview__filters__seeresults-grad" }, null, -1)
const _hoisted_19 = { class: "job-overview__filters__seeresults-button" }
const _hoisted_20 = { class: "job-overview__job" }
const _hoisted_21 = ["id", "value"]
const _hoisted_22 = { class: "job-overview__job__info" }
const _hoisted_23 = { class: "job-overview__job__basicinfo" }
const _hoisted_24 = { class: "job-overview__titlenew" }
const _hoisted_25 = ["href"]
const _hoisted_26 = {
  key: 0,
  class: "job-overview__new"
}
const _hoisted_27 = { class: "job-overview__job-text" }
const _hoisted_28 = { class: "job-overview__job-texlight" }
const _hoisted_29 = { class: "" }
const _hoisted_30 = { class: "job-overview__job-country job-overview__job-text" }
const _hoisted_31 = { class: "job-overview__job__info" }
const _hoisted_32 = { class: "job-overview-details" }
const _hoisted_33 = {
  key: 0,
  class: "job-overview__job-textbold"
}
const _hoisted_34 = {
  key: 1,
  class: "job-overview__job-text"
}
const _hoisted_35 = {
  key: 2,
  class: "job-overview__job-textbold"
}
const _hoisted_36 = {
  key: 3,
  class: "job-overview__job-text"
}
const _hoisted_37 = {
  key: 4,
  class: "job-overview__job-textbold job-overview__job-text-hidden"
}
const _hoisted_38 = {
  key: 5,
  class: "job-overview__job-text job-overview__job-text-hidden"
}
const _hoisted_39 = {
  key: 0,
  class: "job-overview-details"
}
const _hoisted_40 = { class: "job-overview__job-textbold job-overview__job-text-show" }
const _hoisted_41 = { class: "job-overview__job-text job-overview__job-text-show" }
const _hoisted_42 = { class: "job-overview__job-description" }
const _hoisted_43 = { class: "job-overview__job-textbold" }
const _hoisted_44 = { class: "job-overview__job-text" }
const _hoisted_45 = ["href"]
const _hoisted_46 = { class: "job-overview__more" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dropdown_item = _resolveComponent("dropdown-item")!
  const _component_vit_dropdown = _resolveComponent("vit-dropdown")!
  const _component_icon = _resolveComponent("icon")!
  const _component_vit_accordion = _resolveComponent("vit-accordion")!

  return (_openBlock(), _createElementBlock("div", {
    onScroll: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: _normalizeClass(_ctx.filtersOn? 'button button--cross' : 'button button--filter'),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.filtersOpenClose && _ctx.filtersOpenClose(...args)))
        }, _toDisplayString(_ctx.filtersOn ? _ctx.translations.closeFilter : _ctx.filtersCountUsed ? _ctx.translations.filter + ' (' + _ctx.filtersCountUsed + ')' : _ctx.translations.filter), 3),
        (_ctx.filtersUsed && !_ctx.filtersOn)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "button button--link",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cleanFilters && _ctx.cleanFilters(...args)))
            }, _toDisplayString(_ctx.translations.cleanFilter), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.translations.sortBy), 1),
          _createVNode(_component_vit_dropdown, {
            label: _ctx.sortBy ? _ctx.sortBy: 'Relevance' ,
            rounded: "",
            light: ""
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortByOptions, (sort, index) => {
                return (_openBlock(), _createBlock(_component_dropdown_item, {
                  key: index,
                  onClick: ($event: any) => (_ctx.sortBy = _ctx.sortByOptions[index].text),
                  class: _normalizeClass({ 'dropdown__item-link-active': sort.text === _ctx.sortBy})
                }, {
                  default: _withCtx(() => [
                    _hoisted_5,
                    _createElementVNode("span", _hoisted_6, _toDisplayString(sort.text), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick", "class"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        (_ctx.jobsList)
          ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.jobsList.length > 300 ? '300+ ' + _ctx.translations.results : _ctx.allresults.length + ' ' + _ctx.translations.results), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([{'job-overview__content': _ctx.filtersOn }])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass([[{'job-overview__filters-active': _ctx.filtersOn}], "job-overview__filters"])
      }, [
        _createElementVNode("div", {
          class: "job-overview__filters-cross",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.filtersOpenClose && _ctx.filtersOpenClose(...args)))
        }, [
          _createVNode(_component_icon, {
            name: "icn-cross",
            class: "icon job-overview__filters-cross-icon"
          })
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("p", null, _toDisplayString(_ctx.translations.filterBy), 1),
            (_ctx.filtersUsed)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "button button--link",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.cleanFilters && _ctx.cleanFilters(...args)))
                }, _toDisplayString(_ctx.translations.cleanFilter), 1))
              : _createCommentVNode("", true)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters, (filter, index) => {
            return (_openBlock(), _createBlock(_component_vit_accordion, {
              key: index,
              title: filter.checked.length ? filter.filter+' ('+filter.checked.length+')':filter.filter
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  (filter.options.length > 4)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_icon, {
                            name: "icn-search",
                            class: "icon job-overview__filters__search-icon-icon"
                          })
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          class: "job-overview__filters__search-input",
                          "onUpdate:modelValue": ($event: any) => ((filter.search) = $event),
                          onInput: ($event: any) => (_ctx.updateFilters(filter)),
                          placeholder: ""
                        }, null, 40, _hoisted_12), [
                          [_vModelText, filter.search]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filter.optionsSearch, (option, optionindex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: optionindex,
                      class: _normalizeClass(["job-overview__filters__options", { 'hidden-job': optionindex >= filter.optionsOpen }])
                    }, [
                      _createElementVNode("label", {
                        for: option.value
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          id: option.value,
                          value: option.value,
                          "onUpdate:modelValue": ($event: any) => ((filter.checked) = $event),
                          class: "job-overview__filters__options-input"
                        }, null, 8, _hoisted_14), [
                          [_vModelCheckbox, filter.checked]
                        ]),
                        _hoisted_15,
                        _createElementVNode("p", null, _toDisplayString(option.value), 1)
                      ], 8, _hoisted_13)
                    ], 2))
                  }), 128)),
                  (filter.optionsOpen < filter.optionsSearch.length)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "button button--link",
                        onClick: ($event: any) => {filter.optionsOpen=filter.optionsOpen+4;}
                      }, _toDisplayString(_ctx.translations.loadMore), 9, _hoisted_16))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 2
            }, 1032, ["title"]))
          }), 128))
        ]),
        (_ctx.filtersUsed)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("button", {
                  class: "button",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.filtersOpenClose && _ctx.filtersOpenClose(...args)))
                }, _toDisplayString(_ctx.allresults.length ? 'Show all ' + _ctx.allresults.length + ' results' : 'No results'), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", _hoisted_20, [
        _createVNode(_TransitionGroup, { name: "joblist" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allresults, (job, index) => {
              return (_openBlock(), _createBlock(_component_vit_accordion, {
                key: index,
                class: _normalizeClass({ 'hidden-job': _ctx.showJobs < index + 1 })
              }, {
                toggle: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "job-overview__job-fav",
                    onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
                  }, [
                    _createElementVNode("label", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        id: job.jobId,
                        value: job.jobId,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.favourites) = $event)),
                        class: "job-overview__job-fav-icon-input"
                      }, null, 8, _hoisted_21), [
                        [_vModelCheckbox, _ctx.favourites]
                      ]),
                      _createVNode(_component_icon, {
                        name: "icn-star",
                        class: _normalizeClass(["job-overview__job-fav-icon", [{'job-overview__job-fav-icon-active': _ctx.favourites.includes(job.jobId)}]])
                      }, null, 8, ["class"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", null, [
                        _createElementVNode("p", _hoisted_24, [
                          _createElementVNode("a", {
                            onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"])),
                            href: _ctx.determineJobDetailsPageUrl(job.jobId),
                            class: "button button--linkover job-overview__job-title"
                          }, _toDisplayString(job.title), 9, _hoisted_25),
                          (job.postDateString > _ctx.jobisnew)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.translations.new), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("p", _hoisted_27, _toDisplayString(job.businessArea), 1),
                        _createElementVNode("p", _hoisted_28, _toDisplayString(job.postDateString), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.getCountry(job)), 1)
                    ])
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        (job.jobId)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_33, _toDisplayString(_ctx.translations.jobId), 1))
                          : _createCommentVNode("", true),
                        (job.jobId)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_34, _toDisplayString(job.jobId), 1))
                          : _createCommentVNode("", true),
                        (job.employmentType)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_35, _toDisplayString(_ctx.translations.type), 1))
                          : _createCommentVNode("", true),
                        (job.employmentType)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_36, _toDisplayString(job.employmentType), 1))
                          : _createCommentVNode("", true),
                        (job.closingDateString)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_37, _toDisplayString(_ctx.translations.closeDate), 1))
                          : _createCommentVNode("", true),
                        (job.closingDateString)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_38, _toDisplayString(job.closingDateString.substring(0, 10)), 1))
                          : _createCommentVNode("", true)
                      ]),
                      (job.closingDateString)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                            _createElementVNode("p", _hoisted_40, _toDisplayString(_ctx.translations.closeDate), 1),
                            _createElementVNode("p", _hoisted_41, _toDisplayString(job.closingDateString.substring(0, 10)), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("p", _hoisted_43, _toDisplayString(_ctx.translations.jobDescription), 1),
                      _createElementVNode("div", _hoisted_44, _toDisplayString(job.descriptionAbstract), 1)
                    ]),
                    _createElementVNode("a", {
                      class: "job-overview__job-button button",
                      href: _ctx.determineJobDetailsPageUrl(job.jobId)
                    }, _toDisplayString(_ctx.translations.goToJob), 9, _hoisted_45)
                  ])
                ]),
                _: 2
              }, 1032, ["class"]))
            }), 128))
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_46, [
          (_ctx.showJobs < _ctx.allresults.length)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "button button--down",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.moreJobs && _ctx.moreJobs(...args)))
              }, _toDisplayString(_ctx.translations.loadMore), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ], 2)
  ], 32))
}